// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7c7334bc","298":"aa118d9e","453":"1b91ca30","888":"87b872cf"}[chunkId] + ".chunk.js";
};